import { FC, memo } from 'react';

import { getImageByLargestSize } from '@gem/modules/image-resizer';
import { RemoteImage } from '@gem/modules/remote-storage';

import { STICKER_BUBBLE_MAX_WIDTH } from 'APP/constants/stickers';

interface IStaticStickerProps {
  staticUrl: string;
  width: number;
  height: number;
}
export const StaticSticker: FC<IStaticStickerProps> = memo((props) => {
  const { staticUrl, width, height } = props;
  // the same url as in sticker bubble
  const resizedUrl = getImageByLargestSize(staticUrl, STICKER_BUBBLE_MAX_WIDTH);

  return (
    <RemoteImage
      src={resizedUrl}
      alt=""
      width={width}
      height={height}
    />
  );
});
